import styled from "styled-components";
import { Cores } from "../../styles/GlobalStyles";

export const BrandsContainer = styled.section`
  width: 100%;
  padding: 1rem 0;
  background: linear-gradient(to bottom, ${Cores.white}, #f8f9fa);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);

  p {
    color: #666;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 0.25rem;
    font-size: 1.1rem;
    line-height: 1.6;
  }

  .brands-grid {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    flex-wrap: wrap;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    padding: 0.75rem 0;
    gap: 0.5rem;

    p {
      font-size: 1rem;
      padding: 0 1rem;
    }

    .brands-grid {
      gap: 2rem;
      padding: 0 1rem;
    }
  }
`;

export const BrandItem = styled.div`
  position: relative;

  svg {
    font-size: 4rem;
    display: block;
  }

  @media (max-width: 768px) {
    svg {
      font-size: 3rem;
    }
  }
`;
